import React from 'react';
import defaultClasses from './controlSideLabel.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';

const ControlSideLabel = props => {
    const { label: fullLabel } = props;

    const classes = useStyle(defaultClasses, props.classes);

    const [code, label] = fullLabel.split(/ *- */, 2);

    return (
        <div>
            <span className={classes.code}>{code}</span>
            <span className={classes.label}>{label}</span>
        </div>
    );
};

export default ControlSideLabel;
